import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TableOfContents from "../components/table-of-contents";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { solutionsSubMenu } from "../data/solutions-sub-menu";
import { useScrollTop } from "../hook/useScrollTop";
import ColocationSection from "../sections/colocation";
import ManageServicesSection from "../sections/manage-services";
import SaleAndLeaseback from "../sections/sale-and-leaseback";

const Solutions = () => {
  const { data, isLoading } = useQuery(["solution"], async () => {
    const response = await window.fetch(`${BASE_URL}/solution`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  const {
    solution_service,
    solution_sale,
    solution_product,
    solution_product_slider,
    solution_in_building_solution,
    solution_colocation,
    solution_build,
    solution_banner,
  } = data?.solution;

  return (
    <>
      <Helmet>
        <title>AFRO || Solution</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={Boolean(solution_banner?.default) ? "video" : "image"}
        videoURL={solution_banner?.video}
        imageURL={solution_banner?.image}
      >
        <div className="pt-7 pb-5 text-center">
          <h1
            className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size"
            dangerouslySetInnerHTML={{ __html: solution_banner?.title }}
          />
        </div>
      </Header>
      <section className="pb-7">
        <section className="d-none d-lg-block">
          <ul className="row text-center bg-bright-gray fs-14 list-style-none m-0 p-0">
            {solutionsSubMenu.map((menu) => (
              <li
                key={menu.id}
                className="col-3 fs-16  border-gray submenu-link"
              >
                <a
                  href={menu.link}
                  className="text-decoration-none text-orange-ryb gilroy-bold py-4 d-block"
                >
                  {menu.label}
                </a>
              </li>
            ))}
          </ul>
        </section>
        <TableOfContents routes={solutionsSubMenu} />
        <section className="container-fluid mt-9">
          <div className="ms-47 me-47">
            <section className="pb-7">
              <h2 className="fs-30 lh-40 pb-4">Solutions</h2>
              <div
                className="solution-video"
                dangerouslySetInnerHTML={{ __html: solution_banner?.embedded }}
              />
            </section>
            <hr />
            <section className="pt-7 pb-7" id="our-solutions">
              <h2 className="fs-30 pb-4">{solution_product?.title}</h2>
              <p
                className="fs-16"
                dangerouslySetInnerHTML={{
                  __html: solution_product?.description,
                }}
              />
              <div className="row mt-5">
                {solution_product_slider?.map((solution, index) => (
                  <div
                    className="col-12 col-md-4"
                    key={index}
                    data-aos={`${
                      (index === 0 && "fade-right") ||
                      (index === 1 && "fade-up") ||
                      (index === 2 && "fade-left")
                    }`}
                    data-aos-duration="3000"
                  >
                    <div className="m-3 text-center">
                      <img
                        src={`${IMAGE_BASE_URL}/${solution?.image}`}
                        alt=""
                      />
                      <h3 className="fs-18 gilroy-bold">{solution.title}</h3>
                      <p
                        className="fs-16 text-align-justify"
                        dangerouslySetInnerHTML={{
                          __html: solution?.description,
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </section>
            <hr />
            <ColocationSection solution_colocation={solution_colocation} />
            <hr />
            {/* <BuildToSuitSection solution_build={solution_build} />
            <hr /> */}
            <SaleAndLeaseback solution_sale={solution_sale} />
            <hr />
            {/* <SmallCells
              solution_in_building_solution={solution_in_building_solution}
            />
            <hr /> */}
            <ManageServicesSection solution_service={solution_service} />
            <hr />
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default Solutions;
